module.exports = __webpack_public_path__ + "img/1513041687.00ee3b39.jpg";